import { type ComputedRef, type Ref, computed } from 'vue'
import { useDisplay } from 'vuetify'

export interface IUseFormEmbeddedLayoutReturn {
  isEmbedded: ComputedRef<boolean>
  contentClass: ComputedRef<string | undefined>
  maxWidth: ComputedRef<number | undefined>
}

export const EMBEDDED_FORM_CONTENT_CLASS = 'entity-form-embedded'

export const DEFAULT_FORM_MAX_WIDTH = 1000

export function useFormEmbeddedLayout(isEditMode: Ref<boolean> | ComputedRef<boolean>): IUseFormEmbeddedLayoutReturn {
  const { mdAndUp } = useDisplay()

  const isEmbedded = computed(() => mdAndUp.value && isEditMode.value)

  const contentClass = computed(() =>
    isEmbedded.value ? EMBEDDED_FORM_CONTENT_CLASS : undefined,
  )

  const maxWidth = computed(() =>
    isEmbedded.value ? undefined : DEFAULT_FORM_MAX_WIDTH,
  )

  return { isEmbedded, contentClass, maxWidth }
}
